import { lazy } from "react";

const CreditLimitExtensionLoadable = lazy(() => import("./Extension"));
const CreditLimitRequestsLoadable = lazy(() => import("./Requests"));

export {
    CreditLimitExtensionLoadable,
    CreditLimitRequestsLoadable,
};